module.exports = __webpack_public_path__ + "static/media/newsletter-image.47f20e82.jpg";